import React, { useState } from 'react';

import AppContext from '../context/AppContext';

export default function AppProvider({ children }) {
  const [listItems, setListItems] = useState([]);
  const [paginator, setPaginator] = useState({ currentPage: 1, totalPages: 0 });
  const [sorting, setSorting] = useState({ sortBy: '', order: 'asc' });
  const [filter, setFilter] = useState({ search: '', filter: '' });
  const [modal, setModal] = useState({ id: 0, link: '', title: '', show: false });
  const [loading, setLoading] = useState(false);

  return (
    <AppContext.Provider value={{
      listItems, setListItems,
      paginator, setPaginator,
      sorting, setSorting,
      filter, setFilter,
      modal, setModal,
      loading, setLoading
    }}>
      {children}
    </AppContext.Provider>
  );
}